namespace ui
{
	export namespace state
	{
		export namespace progression
		{

			export interface IProgressBarCreateInfo extends ui.base.IBaseHTMLElementDescriptor
			{
				// TODO Notwendige Daten/Attribute einfügen
			}

			export class ProgressBar
				extends ui.base.BaseHTMLElement
			{

				public readonly	Descriptor:	IProgressBarCreateInfo;

				public constructor( createinfo: IProgressBarCreateInfo )
				{
					super( 'progress' );

					this.Descriptor	= createinfo;
				}

				public Initialize(): ProgressBar
				{
					super.Initialize( this.Descriptor );

					// TODO Initialisierung der notwendigen Daten/Attribute

					return this;
				}

			}

		}
	}
}
